import { ENDPOINTS } from "@app/constants";
import { useRequestCallback } from "@fsg/next-auth";
import { ButtonV2, useNotification } from "@gui";
import { useRouter } from 'next/navigation'
import { useCallback, useEffect, useRef, useState } from "react";
import { useRootModal } from "../RootModal/RootModal";
import { ModalContent } from "@app/hooks/grid/useExportAllData";

export function ExportAllOpps() {

    const router = useRouter()
    const { request } = useRequestCallback()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')
    const modal = useRootModal()
    const notification = useNotification()
    const controllerRef = useRef<AbortController>()

    const handleCancel = useCallback(() => {
        if (controllerRef.current) {
            controllerRef.current.abort()
            setIsLoading(false)
            modal.api.setModalContent('Export cancelled')
            modal.api.close()
        }
    }, [modal.api])

    const exportData = async () => {
        controllerRef.current = new AbortController();
        try {
            setIsLoading(true)
            modal.api.create({ size: 'base', onClose: handleCancel })
            modal.api.showModal()
            modal.api.setModalContent(
                <ModalContent>
                    <div className="mb-[8px] text-lg">Exporting all opportunities...</div>
                    <ButtonV2 size="md" variant="secondary" onClick={handleCancel}>
                        Cancel
                    </ButtonV2>
                </ModalContent>,
            )
            await request<any>({
                path: ENDPOINTS.OPPORTUNITIES_EXPORT,
                method: 'GET',
                credentials: 'include',
                omitContentType: true,
                signal: controllerRef.current?.signal,
                responseHandler: async (response) => {
                    const blob = await response.blob()
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = url
                    a.download = `opportunities-export-${new Date().toISOString().split('T')[0]}.csv`
                    document.body.appendChild(a)
                    a.click()
                    window.URL.revokeObjectURL(url)
                    document.body.removeChild(a)
                },
            })
            modal.api.close()
            setIsLoading(false)
            notification.api.notify({
                message: 'Export completed successfully',
                type: 'success',
            })
        } catch (err) {
            if (err instanceof DOMException && err.name === "AbortError") {

                setError('Export cancelled')
                modal.api.setModalContent('Export cancelled')
                notification.api.notify({
                    message: 'Export cancelled by user',
                    type: 'warning',
                })
            } else {
                console.error('Export error:', err)
                setError(err instanceof Error ? err.message : 'An error occurred during export')
                notification.api.notify({
                    message: 'Error exporting data. Please try again.',
                    type: 'warning',
                })
            }
            setIsLoading(false)
            modal.api.close()
        }
    }
    async function handleExportAllNav() {
        router.push('/opportunities/export')
    }

    return (
        <ButtonV2 loading={isLoading} className="font-bold hidden md:block" variant="secondary" size="md" type="button" onClick={exportData}>
            Full Export
        </ButtonV2>
    )
}
